export const numericOnly = /[^0-9.-]/gi
export const numericOnlyPositive = /[^0-9]/gi
export const numericWithTwoDecimals = /(\.\d{2})\d+/g
